module.exports = __webpack_public_path__ + "static/img/AR.21a9afdd.png";